var map = {
	"./assets/imgs/banner1.jpg": "dcab",
	"./assets/imgs/banners/DMC.jpg": "81ac",
	"./assets/imgs/banners/DMC_DSK.jpg": "7139",
	"./assets/imgs/banners/ECOCASANCO.jpg": "4392",
	"./assets/imgs/banners/EQUIPTOP.jpg": "0407",
	"./assets/imgs/banners/FT.jpg": "e810",
	"./assets/imgs/banners/Hessapp.jpg": "0b99",
	"./assets/imgs/banners/IKEGAI.jpg": "a763",
	"./assets/imgs/banners/IMAS.jpg": "6058",
	"./assets/imgs/banners/JOBS.jpg": "fda0",
	"./assets/imgs/banners/LEADWELL.jpg": "fa6e",
	"./assets/imgs/banners/MAG.jpg": "a5de",
	"./assets/imgs/banners/MAG1.jpg": "e256",
	"./assets/imgs/banners/MAG2.jpg": "c053",
	"./assets/imgs/banners/MAG3.jpg": "9ae8",
	"./assets/imgs/banners/MAG4.jpg": "b897",
	"./assets/imgs/banners/MAG5.jpg": "2743",
	"./assets/imgs/banners/MAG6.jpg": "1846",
	"./assets/imgs/banners/MORARA.jpg": "451f4",
	"./assets/imgs/banners/Modul.jpg": "9a25",
	"./assets/imgs/banners/Pfiffner.jpg": "c592",
	"./assets/imgs/banners/Pfiffner1.jpg": "494e",
	"./assets/imgs/banners/Pfiffner2.jpg": "6656",
	"./assets/imgs/banners/Rambaudi.jpg": "688e",
	"./assets/imgs/banners/SEC.jpg": "b498",
	"./assets/imgs/banners/SMS.jpg": "ed0b",
	"./assets/imgs/banners/SNK1.jpg": "2688",
	"./assets/imgs/banners/SNK2.jpg": "73ed",
	"./assets/imgs/banners/Sachman.jpg": "fd6d",
	"./assets/imgs/banners/TACCHELLA.jpg": "356e",
	"./assets/imgs/banners/TAKAMAZ.jpg": "1674",
	"./assets/imgs/banners/Takeuchi.jpg": "9da5",
	"./assets/imgs/banners/VDF.jpg": "9c45",
	"./assets/imgs/banners/WAIDA.jpg": "4bf3",
	"./assets/imgs/banners/feeler.jpg": "06ca",
	"./assets/imgs/banners/mectron.jpg": "2c95",
	"./assets/imgs/banners/taisei.jpg": "0542",
	"./assets/imgs/detail1-2.png": "c119",
	"./assets/imgs/detail1-3.png": "9a53",
	"./assets/imgs/detail1.png": "785a",
	"./assets/imgs/detail2.png": "8740",
	"./assets/imgs/detail3.png": "9afd",
	"./assets/imgs/detail4.png": "2eb2",
	"./assets/imgs/homeBg.jpg": "2a5b",
	"./assets/imgs/index-01.png": "327b",
	"./assets/imgs/index-02.png": "e651",
	"./assets/imgs/index-03.png": "fe76",
	"./assets/imgs/index-04.png": "12d1",
	"./assets/imgs/index-background.png": "3d02",
	"./assets/imgs/indexLogo.png": "da66",
	"./assets/imgs/logo.png": "ede7",
	"./assets/imgs/logos/1-1.png": "730b",
	"./assets/imgs/logos/1-2.png": "34d9",
	"./assets/imgs/logos/1-3.png": "cdfa",
	"./assets/imgs/logos/1-4.png": "4e81",
	"./assets/imgs/logos/1-5.png": "1217",
	"./assets/imgs/logos/1-7.png": "7cfd",
	"./assets/imgs/logos/1-8.png": "5fd1",
	"./assets/imgs/logos/2-1.png": "44ab",
	"./assets/imgs/logos/2-2.png": "ddb1",
	"./assets/imgs/logos/2-3.png": "1b4d",
	"./assets/imgs/logos/2-4.png": "fd1b",
	"./assets/imgs/logos/2-5.png": "4615",
	"./assets/imgs/logos/2-6.png": "7bac",
	"./assets/imgs/logos/2-7.png": "a99b",
	"./assets/imgs/logos/3-1.png": "550b",
	"./assets/imgs/logos/3-2.png": "d36f",
	"./assets/imgs/logos/3-3.png": "311c",
	"./assets/imgs/logos/3-4.png": "8b1d",
	"./assets/imgs/logos/3-5.png": "5f7e",
	"./assets/imgs/logos/3-6.png": "c342",
	"./assets/imgs/logos/3-7.png": "6bde",
	"./assets/imgs/logos/4-1.png": "5763",
	"./assets/imgs/logos/4-2.png": "311e",
	"./assets/imgs/logos/4-3.png": "08df",
	"./assets/imgs/logos/4-4.png": "5503",
	"./assets/imgs/logos/4-5.png": "30bd",
	"./assets/imgs/logos/4-6.png": "42ea",
	"./assets/imgs/logos/4-7.png": "16bf",
	"./assets/imgs/logos/5-1.png": "d4f2",
	"./assets/imgs/logos/5-2.png": "b27c",
	"./assets/imgs/logos/5-3.png": "61df",
	"./assets/imgs/logos/5-4.png": "5700",
	"./assets/imgs/logos/5-5.png": "86df",
	"./assets/imgs/logos/5-6.png": "688d",
	"./assets/imgs/logos/5-7.png": "68a3",
	"./assets/imgs/logos/5-8.png": "ccdb",
	"./assets/imgs/logos/ft1.png": "f1df",
	"./assets/imgs/logs.png": "b8db",
	"./assets/json/detail": "fb63",
	"./assets/json/detail.js": "fb63",
	"./assets/logo.png": "cf05",
	"./assets/logos/CROSSHULLER.png": "fc83",
	"./assets/logos/DMC.png": "b116",
	"./assets/logos/DSK.png": "3c6d",
	"./assets/logos/ECOCA.png": "d62c",
	"./assets/logos/EQUIPTOP.png": "c970",
	"./assets/logos/EXCELLO.png": "8348",
	"./assets/logos/FEELER.png": "e573",
	"./assets/logos/FT.png": "505d",
	"./assets/logos/HESSAPP.png": "3524",
	"./assets/logos/HONSBERG.png": "9616",
	"./assets/logos/IKEGAI.png": "c927",
	"./assets/logos/IMAS.png": "2715",
	"./assets/logos/JOBS.png": "4527",
	"./assets/logos/LAMB.png": "abd0",
	"./assets/logos/LEADWELL.png": "341d",
	"./assets/logos/MAG.png": "6745",
	"./assets/logos/MECCANODORA.png": "5d69",
	"./assets/logos/MECTRONFEELER.png": "d9fc",
	"./assets/logos/MODUL.png": "d5b5",
	"./assets/logos/MORARA.png": "52fa",
	"./assets/logos/NISSIN.png": "3a5a",
	"./assets/logos/PFIFFNER.png": "3d74",
	"./assets/logos/RAMBAUDI.png": "1237",
	"./assets/logos/SACHMAN.png": "97c8",
	"./assets/logos/SANCO.png": "8f35",
	"./assets/logos/SEC.png": "7b2d",
	"./assets/logos/SIGMA.png": "acee",
	"./assets/logos/SMS.png": "8f85",
	"./assets/logos/SNK.png": "3b49",
	"./assets/logos/TACCHELLA.png": "16a3",
	"./assets/logos/TAISEI.png": "8278",
	"./assets/logos/TAKAMAZFEELER.png": "eb7e",
	"./assets/logos/TAKEUCHI.png": "4c05",
	"./assets/logos/VDF.png": "d2dc",
	"./assets/logos/WAIDAZFEELER.png": "620b",
	"./assets/logos/WITZIGFRANK.png": "ed60",
	"./assets/logos/gotomag.png": "8279",
	"./assets/style/rest.css": "f6e5",
	"./assets/video/1-24.webm": "8a60",
	"./assets/video/DMC.webm": "fd59",
	"./assets/video/DSK.webm": "9f06",
	"./assets/video/EQUIPTOP.mp4": "bb94",
	"./assets/video/FEELER.webm": "1b26",
	"./assets/video/FFG.mp4": "3b68",
	"./assets/video/FFG.webm": "3143",
	"./assets/video/HESSAPP.mp4": "220c",
	"./assets/video/IKEGAI.webm": "629a",
	"./assets/video/IMAS.mp4": "642d",
	"./assets/video/JOBS.mp4": "bed6",
	"./assets/video/LEADWELL.mp4": "2b42",
	"./assets/video/MAG.mp4": "a4b1",
	"./assets/video/MORARA.mp4": "e670",
	"./assets/video/Modul.mp4": "3041",
	"./assets/video/NISSIN.mp4": "2470",
	"./assets/video/Rambaudi.mp4": "d5b4",
	"./assets/video/SMS.mp4": "f158",
	"./assets/video/SNK.mp4": "0b1a",
	"./assets/video/Sachman.mp4": "3170",
	"./assets/video/Sigma.mp4": "db27",
	"./assets/video/VDF.webm": "87a9",
	"./assets/video/WAIDA.mp4": "358b",
	"./assets/video/Witzig.mp4": "53eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";